export default function ({ $axios, redirect, store }) {
	$axios.onError((error) => {});
}